import { render, staticRenderFns } from "./dealsTable.vue?vue&type=template&id=9baa62c8&lang=pug"
import script from "./dealsTable.vue?vue&type=script&lang=js"
export * from "./dealsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports